import Collapsible from '@commons/components/Collapsible';
import RichText from '@commons/components/RichText';
import Text, { type TextLevel } from '@commons/components/Text';
import type { DrupalBlock } from '@commons/types/drupal';

// Type definition for the CollapsibleBlock component properties.

type Props = DrupalBlock<{
  title: string;
  titleLevel: TextLevel;
  content: string;
  defaultOpen?: boolean;
}>;

/**
 * Collapsible block component.
 */

const CollapsibleBlock = (props: Props) => {
  const { title, titleLevel, content, defaultOpen = false } = props.content;

  const renderedTitle = (
    <Text as="p" level={titleLevel} marginBottom="none">
      {title}
    </Text>
  );

  return (
    <Collapsible title={renderedTitle} defaultOpen={defaultOpen} className="w-100">
      <RichText width={12} value={content} />
    </Collapsible>
  );
};

export default CollapsibleBlock;
